<template>
  <div class="detail-page" v-if="is_show_page">
    <div class="comm">
      <div class="title font-sc-me">基本资料</div>
      <div class="content">
        <div class="content-item">
          <div class="item-left font-28">行&nbsp;&nbsp;业</div>
          <div class="item-right">{{ detail.industry }}</div>
        </div>
        <div class="content-item m-t-22">
          <div class="item-left font-28">应&nbsp;&nbsp;用</div>
          <div class="item-right">
            <div
              class="application "
              :class="is_show_more ? '' : 'three-line-ellipses'"
            >
              {{ detail.application_position }}
            </div>
            <div
              class="algin-center m-t-8"
              v-if="!is_show_more && detail.application_position.length > 35"
              @click="showMore"
            >
              <div class="more-text">查看更多</div>
              <div class="more flex">
                <img src="../../assets/more_icon.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="content-item m-t-22">
          <div class="item-left font-28">产品推荐</div>
          <div class="item-right">
            <div class="algin-center">
              <div class="max-width">{{ detail.shell_product }}</div>
              <div
                class="question flex"
                v-if="!is_show_type"
                @click="showProductType"
              >
                <img src="../../assets/question_mark.png" alt="" />
              </div>
              <div class="tips flex" v-if="is_show_type">
                <div>（</div>
                <div class="max-width-190 ellipses">
                  {{ detail.basics_type }}
                </div>
                <div>）</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="comm m-t-30" v-if="detail.working_condition">
      <div class="title font-sc-me">工况</div>
      <div class="content line-height-44">{{ detail.working_condition }}</div>
    </div>
    <div class="comm m-t-30" v-if="detail.customer_pain_point.length > 0">
      <div class="title font-sc-me">痛点</div>
      <div class="content line-height-44">
        <div
          class="spot-info algin-center"
          v-for="(item, index) in detail.customer_pain_point"
          :key="index"
        >
          <div class="spot"></div>
          <div class="max-width-558">{{ item }}</div>
        </div>
      </div>
    </div>
    <div class="comm m-t-30" v-if="detail.shell_product_trait.length > 0">
      <div class="title font-sc-me">壳牌产品特性</div>
      <div class="content line-height-44">
        <div
          class="spot-info algin-center"
          v-for="(item, index) in detail.shell_product_trait"
          :key="index"
        >
          <div class="spot"></div>
          <div class="max-width-558">{{ item }}</div>
        </div>
      </div>
    </div>
    <div class="comm m-t-30" v-if="detail.customer_revenue">
      <div class="title font-sc-me">客户收益</div>
      <div class="content line-height-44">{{ detail.customer_revenue }}</div>
    </div>
    <div class="comm m-t-30" v-if="detail.competitor_product.length > 0">
      <div class="title font-sc-me">常见竞品</div>
      <div class="content">
        <div
          class="competitor flex-container"
          v-for="(item, index) in detail.competitor_product"
          :key="index"
          @click="goCompetitor(item.id)"
        >
          <div class="com-with flex">
            <div class="competitor-name ellipses font-sc-me">
              {{ item.brand }}
            </div>
            <div class="ellipses max-width-320">{{ item.product }}</div>
          </div>
          <div class="arrow flex">
            <img src="../../assets/arrow_right_black.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="comm m-t-30" v-if="detail.appendix.length > 0">
      <div class="title font-sc-me">下载资料</div>
      <div class="content">
        <a
          :href="item.file_path"
          :download="item.file_name"
          class="pdf algin-center"
          v-for="(item, index) in detail.appendix"
          :key="index"
        >
          <div class="pdf-img flex">
            <img src="../../assets/pdf_icon.png" alt="" />
          </div>
          <div class="flex-1 m-l-20 ellipses">{{ item.file_name }}</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, toRefs, getCurrentInstance } from "vue";
import { useRouter, useRoute } from "vue-router";
import Api from "../../api/ProductApi";
export default {
  name: "Detail",
  setup() {
    const { proxy } = getCurrentInstance();
    // router 是全局路由对象
    const router = useRouter();
    // route是当前路由对象
    const route = useRoute();
    // query传递过来的参数都是字符串类型
    const id = route.query.id;
    let datas = reactive({
      detail: {
        application_position: "", // 应用描述
        customer_pain_point: [], // 痛点
        shell_product_trait: [], // 壳牌产品特性
        competitor_product: [], // 常见竞品
        appendix: [] // 下载资料
      },
      is_show_page: false, // 是否展示页面
      is_show_type: false, // 是否展示产品类型
      is_show_more: false // 是否展示全部应用
    });
    // 获取详情数据
    const getDetail = async () => {
      proxy.$toast.loading({
        message: "加载中..."
      });
      try {
        const { data } = await Api.oilsDetail({ id: id });
        proxy.$toast.clear();
        datas.is_show_page = true;
        datas.detail = data;
      } catch (error) {
        proxy.$toast.clear();
        console.error(error);
      }
    };
    // 跳转竞品详情
    const goCompetitor = id => {
      router.push({
        name: "CompareDetail",
        query: {
          id: id
        }
      });
    };
    // 展示产品类型
    const showProductType = () => {
      datas.is_show_type = true;
    };
    // 展示全部应用
    const showMore = () => {
      datas.is_show_more = true;
    };
    onMounted(() => {
      getDetail();
    });
    return {
      ...toRefs(datas),
      goCompetitor,
      showProductType,
      showMore
    };
  }
};
</script>

<style lang="sass" scoped>
@import "~@/styles/mixins/vw"
.detail-page
  padding: vw(30) vw(40)
  font-size: vw(32)
  .line-height-44
    line-height: vw(44)
  .comm
    width: 100%
    border-radius: vw(20)
    background: #FFFFFF
    box-shadow: 0 vw(12) vw(32) 0 rgba(35, 36, 46, 0.04)
  .title
    height: vw(68)
    padding: 0 vw(30)
    line-height: vw(68)
    color: #FFFFFF
    border-radius: vw(20) vw(20) 0 0
    background: linear-gradient(304deg, #E1EAFF 0%, #5E7BFF 100%)
  .content
    padding: vw(30) vw(30) vw(38)
    .content-item
      display: flex
      line-height: vw(44)
      .item-left
        width: vw(138)
        height: vw(44)
        line-height: vw(42)
        color: #5E7BFF
        border: vw(2) solid #5E7BFF
        background: #EEF1FF
        text-align: center
      .item-right
        margin-left: vw(30)

        flex: 1
        .application
          line-height: vw(44)
        .more-text
          font-size: vw(24)
          color: #5E7BFF
        .more
          width: vw(18)
          height: vw(14)
          margin-left: vw(6)
        .max-width
          // max-width: vw(200)
        .question
          width: vw(24)
          height: vw(24)
          margin-left: vw(12)
        .tips
          font-size: vw(26)
          color: #999999
        .max-width-190
          max-width: vw(190)

    .spot-info
      margin-bottom: vw(20)
      &:last-child
        margin-bottom: 0
      .spot
        width: vw(12)
        height: vw(12)
        margin-right: vw(34)
        border: vw(2) solid #5E7BFF
        background: #EEF1FF
      .max-width-558
        max-width: vw(558)
    .competitor
      height: vw(44)
      margin-bottom: vw(28)
      padding: 0 vw(20)
      background: linear-gradient(90deg, #FCFCFC 0%, #F7F7F7 100%)
      &:last-child
        margin-bottom: 0
      .com-with
        width: vw(580)
      .competitor-name
        width: vw(170)
        margin-right: vw(36)
        color: #5E7BFF
      .max-width-320
        max-width: vw(320)
      .arrow
        width: vw(10)
        height: vw(20)
    .pdf
      margin-bottom: vw(18)
      &:last-child
        margin-bottom: 0
      .pdf-img
        width: vw(36)
        height: vw(40)
.detail-page::-webkit-scrollbar
  display: none
</style>
